import { Fragment } from 'react';

type LineItemIdentifiersProps = {
  parts: Array<string | undefined>;
  className?: string;
};

/**
 * Renders the muted identifier line under a line-item name (e.g. GTIN, receiver and
 * supplier article numbers), joining the present parts with a middle dot. Renders
 * nothing when no part is present, so callers can pass whichever identifiers apply.
 * The line wraps onto a second line when the parts don't fit, then clamps with an
 * ellipsis so cards keep a bounded height in the draggable list. Each part is kept on
 * a single line, so a wrap only ever lands at a separator (before the next
 * identifier's label) rather than splitting a "label: value" pair across two lines.
 */
export const LineItemIdentifiers = ({ parts, className }: LineItemIdentifiersProps) => {
  const present = parts.filter((part): part is string => Boolean(part));
  if (present.length === 0) {
    return null;
  }
  return (
    <p className={className ?? 'line-clamp-2 text-xs leading-4 text-gray-500'}>
      {present.map((part, index) => (
        <Fragment key={index}>
          {index > 0 ? ' · ' : null}
          <span className="whitespace-nowrap">{part}</span>
        </Fragment>
      ))}
    </p>
  );
};
